import { colors } from '../constants';

/**
 * Get color for status chip
 * @param {string} status - Status value
 * @returns {string} Color value
 */
export const getStatusColor = (status) => {
  if (!status) return colors.textSecondary;
  
  const normalized = status.toString().trim().toLowerCase();
  
  switch (normalized) {
    case 'raised':
    case 'open':
      return colors.info;
    case 'responded':
    case 'pending':
      return colors.primaryDark;
    case 'closed':
      return colors.success;
    case 'escalated':
      return colors.warning;
    case 'delegated':
      return colors.info;
    case 'resolved':
      return colors.success;
    case 'reopened':
      return colors.secondary;
    case 'additional_clarification':
      return '#f59e0b'; // Orange/amber color for clarification needed
    default:
      return colors.textSecondary;
  }
};

/**
 * Get color for priority chip
 * @param {string} priority - Priority value
 * @returns {string} Color value
 */
export const getPriorityColor = (priority) => {
  if (!priority) return colors.textSecondary;
  
  const normalized = priority.toString().trim().toLowerCase();
  
  switch (normalized) {
    case 'high':
      return colors.error;
    case 'medium':
      return colors.warning;
    case 'low':
      return colors.info;
    default:
      return colors.textSecondary;
  }
};

/**
 * Format status value for display
 * @param {string} status - Status value
 * @returns {string} Formatted status
 */
export const formatStatusValue = (status) => {
  if (!status) return '';

  const normalized = status.toString().trim().toLowerCase();
  if (normalized === 'reopened') {
    return 'Need Clarification';
  }

  return status
    .toString()
    .replace(/_/g, ' ')
    .toLowerCase()
    .replace(/\b\w/g, (char) => char.toUpperCase());
};

/**
 * Get user initials from name
 * @param {string} name - User name
 * @returns {string} Initials (1-2 characters)
 */
export const getUserInitials = (name = '') => {
  if (!name) return '?';
  const parts = name.trim().split(' ');
  if (parts.length === 1) {
    return parts[0].charAt(0).toUpperCase();
  }
  return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
};

/**
 * Get user display name from user object
 * @param {Object} user - User object
 * @returns {string} Display name
 */
export const getUserDisplayName = (user = {}) => {
  if (!user) return '';
  const name =
    user.full_name ||
    user.name ||
    user.fullName ||
    [user.firstName, user.lastName].filter(Boolean).join(' ') ||
    user.username ||
    user.email ||
    '';
  return name;
};

/**
 * Extract ID from entity (handles both object and string)
 * @param {Object|string|number} entity - Entity to extract ID from
 * @returns {string} ID string
 */
export const extractId = (entity) => {
  if (!entity && entity !== 0) return '';
  if (typeof entity === 'string' || typeof entity === 'number') {
    return entity.toString();
  }
  if (entity._id) return entity._id.toString();
  if (entity.id) return entity.id.toString();
  return '';
};
